/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CloseReasonDto } from './CloseReasonDto';
import {
    CloseReasonDtoFromJSON,
    CloseReasonDtoFromJSONTyped,
    CloseReasonDtoToJSON,
    CloseReasonDtoToJSONTyped,
} from './CloseReasonDto';

/**
 * Case resolution data
 * @export
 * @interface CloseCaseRequest
 */
export interface CloseCaseRequest {
    /**
     * Close reason details
     * @type {CloseReasonDto}
     * @memberof CloseCaseRequest
     */
    closeReason?: CloseReasonDto;
    /**
     * Detailed rationale for closing the case
     * @type {string}
     * @memberof CloseCaseRequest
     */
    closeRationale?: string;
    /**
     * Feedback about the case handling process
     * @type {string}
     * @memberof CloseCaseRequest
     */
    feedback?: string;
    /**
     * Optional timestamp for when case was closed (if not provided, uses current time)
     * @type {Date}
     * @memberof CloseCaseRequest
     */
    closedTime?: Date;
}

/**
 * Check if a given object implements the CloseCaseRequest interface.
 */
export function instanceOfCloseCaseRequest(value: object): value is CloseCaseRequest {
    return true;
}

export function CloseCaseRequestFromJSON(json: any): CloseCaseRequest {
    return CloseCaseRequestFromJSONTyped(json, false);
}

export function CloseCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'closeReason': json['closeReason'] == null ? undefined : CloseReasonDtoFromJSON(json['closeReason']),
        'closeRationale': json['closeRationale'] == null ? undefined : json['closeRationale'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'closedTime': json['closedTime'] == null ? undefined : (new Date(json['closedTime'])),
    };
}

export function CloseCaseRequestToJSON(json: any): CloseCaseRequest {
    return CloseCaseRequestToJSONTyped(json, false);
}

export function CloseCaseRequestToJSONTyped(value?: CloseCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'closeReason': CloseReasonDtoToJSON(value['closeReason']),
        'closeRationale': value['closeRationale'],
        'feedback': value['feedback'],
        'closedTime': value['closedTime'] == null ? undefined : ((value['closedTime']).toISOString()),
    };
}

